import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  getAppViewerModuleNewTabUrl,
  getAppViewerModuleTempDashboardUrl,
} from '@components/common/Dashboard/utils/getTempDashboardUrl';
import { DASHBOARD_TYPE } from '@utils/constants';
import { createTempDashboard } from '@store/tempDashboard/actions';
import { Tooltip } from 'antd';

interface IAppViewerCellProps {
  type: 'user' | 'client';
  userId?: string;
  clientId?: string;
}

function AppViewerCell(props: IAppViewerCellProps): JSX.Element {
  const { userId, clientId, type = 'user' } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const id = type === 'user' ? userId : clientId;
  const handleEvent: any = (event) => {
    if (userId || clientId) {
      event.preventDefault();
      // callback to push new temp tab url
      const redirectHandler = ({ id }) => {
        history.push(getAppViewerModuleTempDashboardUrl({ viewerId: userId, clientId }, id));
      };
      const title = type === 'user' ? 'User' : 'Client';
      // create local storage entry
      dispatch(
        createTempDashboard(
          DASHBOARD_TYPE.APP_VIEWER_MODULE,
          { viewerId: userId, clientId },
          `${title} - ${id}`,
          { redirectHandler },
        ),
      );
    }
  };

  return (
    <Tooltip title={id} placement="topLeft">
      {id === 'UNKNOWN' ? (
        <span>{id}</span>
      ) : (
        <a
          style={{
            color: '#1890ff',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
          href={getAppViewerModuleNewTabUrl(userId)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleEvent}
        >
          {id}
        </a>
      )}
    </Tooltip>
  );
}

export default React.memo(AppViewerCell);
